import { render } from "./ResponseSkeleton.vue?vue&type=template&id=32f11230&scoped=true"
const script = {}

import "./ResponseSkeleton.vue?vue&type=style&index=0&id=32f11230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f11230"]])

export default __exports__